import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { post } from '../../lib/api';
import { Button } from '../../components/ui/button';
import { ErrorNotice } from '../../components/ui/common';
import './development-login.css';

export function DevelopmentLogin() {
  const [role, setRole] = useState('admin');
  const query = useQueryClient();
  const login = useMutation({ mutationFn: () => post('/auth/dev-login', { role }), onSuccess: () => { void query.invalidateQueries(); } });
  return <section className="development-login" aria-label="Local development sign-in">
    <h3>Local development</h3>
    <p>Bypass the passkey to test a user role on localhost.</p>
    <label className="field">Sign in as<select value={role} onChange={event => setRole(event.target.value)} disabled={login.isPending}>
      <option value="admin">Admin — full access</option><option value="editor">Editor — manage investment records</option><option value="viewer">Viewer — read only</option>
    </select></label>
    <Button variant="outline" onClick={() => login.mutate()} disabled={login.isPending}>{login.isPending ? 'Signing in…' : 'Bypass login'}</Button>
    {login.error && <ErrorNotice error={login.error} />}
  </section>;
}
